import React from "react";

const KnowMore4 = () => {
    return (
        <div className="select-none  w-full overflow-x-hidden mt-5 lg:mt-10">
            <img data-aos="zoom-in-left" className="hidden lg:block md:block absolute mt-[30rem] w-[70rem]" src="https://i.ibb.co/7GgSKJp/cloud7.png" alt="cloud7"/>
            <div className="md:flex lg:flex md:mx-6">
                <div data-aos="fade-out" className="md:mt-4 lg:px-14 p-2 bg-slate-100 bg-opacity-40 border-4 border-white/60 lg:rounded-tr-[5rem] lg:rounded-bl-[5rem] md:rounded-tr-[3rem] md:rounded-bl-[3rem]">
                    <div className="flex items-center px-2 rounded-br-3xl shadow-md bg-cyan-200 bg-opacity-30 lg:w-1/2 md:w-3/4 w-3/4">
                        <img src="https://i.ibb.co/LvSjm3w/lg.png" alt="" />
                        <p className="p-2 md:ml-2 lg:ml-4 text-xs md:text-lg lg:text-xl text-red-500 font-extrabold lg:tracking-wide">
                            VERIFY
                        </p>
                    </div>
                    <div className="p-2 text-[12px] md:text-xs lg:text-xl text-grey md:p-2 lg:p-5 lg:tracking-wider">
                    To collect documents and verify that the user is actually the said
                        person. We use user's marurity & collect certain set of documents to
                        verify the users.
                        <hr /> Students can add an idea, collaborate with other selected
                        ideas. <hr /> Faculties can collaborate with others, principals,
                        other faculties, CEOs, IT professionals, conduct sessions, hire
                        students, give projects, etc. <hr /> IT professionals can
                        collaborate with others, principals, other faculties, CEOs, IT
                        professionals, conduct sessions, hire students, give projects, etc.
                    </div>
                </div>

                <img
                    src="https://i.ibb.co/fHdXS3v/join.png"
                    className=" h-[4rem] md:h-[6rem] lg:w-auto lg:h-[10rem] lg:place-self-center md:place-self-center mx-auto"
                    alt=""
                />


                <div data-aos="fade-out" className="lg:mt-6 md:mt-6 lg:px-14 p-2 bg-slate-100 bg-opacity-40 border-4 border-white/60 lg:rounded-tr-[5rem] lg:rounded-bl-[5rem] md:rounded-tr-[3rem] md:rounded-bl-[3rem]">
                    <div className="flex items-center px-2 rounded-br-3xl shadow-md bg-cyan-200 bg-opacity-30 lg:w-1/2 md:w-3/4 w-3/4">
                        <img src="https://i.ibb.co/LvSjm3w/lg.png" alt="" />
                        <p className="p-2 md:ml-2 lg:ml-4 text-xs lg:text-xl md:text-lg text-red-500 font-extrabold lg:tracking-wide">
                            LOGIN
                        </p>
                    </div>
                    <div className="p-2 text-[12px] md:text-xs lg:text-xl text-grey md:p-2 lg:p-5 lg:tracking-wider">
                        It just creates an account through which one can see the generalized
                        content. This information will be used for further authentication.
                        <hr />
                        Students can see verified & selected ideas, Like and comment, etc.{" "}
                        <hr />
                        Faculties can upload idedas, see verified & selected ideas, join
                        sessions, like & comment, etc. <hr /> IT professionals can upload
                        idedas, see verified & selected ideas, join sessions, like &
                        comment, etc.
                    </div>
                </div>

            </div>


            <div className="relative flex pt-4">
            <div className="select-none mt-2 md:mt-4 lg:mt-4 md:mx-6 lg:mx-14 p-2 bg-slate-100 bg-opacity-40 border-4 border-white/60 lg:rounded-tr-[5rem] lg:rounded-bl-[5rem] md:rounded-tr-[3rem] md:rounded-bl-[3rem]">
                    <div className="flex items-center px-2 rounded-br-3xl shadow-md bg-cyan-200 bg-opacity-30 lg:w-1/2 md:w-1/2 w-3/4">
                        <img src="https://i.ibb.co/NFhtrzB/yt.png" alt="" />
                        <p className="select-none md:ml-2 text-xs ml-2 md:text-sm lg:ml-4 lg:text-xl text-red-500 font-extrabold lg:tracking-wide">
                            SESSIONS
                        </p>
                    </div>
                    <div className="select-none text-[12px] p-2 md:text-xs lg:text-xl text-grey md:p-3 lg:p-5 lg:tracking-wider">
                        Users may get extra knowledge through various online sessions
                        conducted through Modernvate. Users can uplift their skills by
                        learning things professionally. Verified Institutes/
                        organizations can conduct these sessions.These  will be
                        extremly informative which will help students find and work on their
                        next upcoming ideas.
                    </div>
                </div>
                <img
                    className="select-none hidden lg:block md:block h-28 w-auto lg:h-96 lg:w-auto md:h-44 md:w-auto md:pt-6 md:pl-6 lg:pt-6 lg:pl-6"
                    src="https://i.ibb.co/xH7vQcg/img4.png"
                    alt=""
                />
            </div>
            <br />
        </div>
    );
};

export default KnowMore4;